
export const STATUS_REPORT = 'https://dvschema.io/activation#StatusReport';
export const REPORT_CREATED = 'https://dvschema.io/activation#ActivityReportCreated';
export const HISTORY_REPORT = 'https://dvschema.io/activation#ActivityReportStatusReport';
export const HISTORY_RESPONSE = 'https://dvschema.io/activation#ActivityReportStatusResponse';